export const rootLineHeight = 1.42857143;
export const rootFontSize = 14;
export const rootAbsoluteLineHeight = rootLineHeight * rootFontSize;
export const getGlobalTheme = (): 'light' | 'dark' => {
	// Determine global theme
	const documentElement = document.documentElement;
	const rawTheme: string | null = documentElement.getAttribute('data-theme');
	return rawTheme === 'dark' ? 'dark' : 'light';
};
